import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSystemStatusThunk,
  selectSystemStatusCounts,
  selectSystemStatusError,
  selectSystemStatusHasLoaded,
  selectSystemStatusLoading,
  selectSystemStatusServices,
} from "../store/supportSlice";

export const useSystemStatus = () => {
  const dispatch = useDispatch();
  const services = useSelector(selectSystemStatusServices);
  const statusCounts = useSelector(selectSystemStatusCounts);
  const isLoading = useSelector(selectSystemStatusLoading);
  const error = useSelector(selectSystemStatusError);
  const hasLoaded = useSelector(selectSystemStatusHasLoaded);

  const loadSystemStatus = useCallback(() => {
    dispatch(fetchSystemStatusThunk());
  }, [dispatch]);

  useEffect(() => {
    if (!hasLoaded) {
      loadSystemStatus();
    }
  }, [hasLoaded, loadSystemStatus]);

  return {
    services,
    isLoading,
    error,
    statusCounts,
    refresh: loadSystemStatus,
  };
};

export default useSystemStatus;